// src/config.ts
const isProduction = true;

const config = {
  API_BASE_URL: isProduction
    ? 'https://www.platefullai.com'
    : 'http://localhost:8000',
};

export default config;